import React from 'react';
import CommunityPage from './CommunityPage';
import {DocumentTitle, FancyCheckbox, Spinner, ShareableLink} from '../widgets';
import './CommunityAdminPage.css';
import actions from './community.actions';
import {connect} from 'react-redux';
import {
	getSessionUserMembership,
	getParamsUniqueName,
	getProfileUniqueName
} from './community.selectors';
import FancyButton from '../widgets/FancyButton';
import confirmActions from '../widgets/confirmation.actions';
import {uiActions} from '../chrome';

class CommunityAdminPage extends CommunityPage {
	constructor(props) {
		super(props);

		const paramUniqueName = getParamsUniqueName(this.props);
		if (
			paramUniqueName &&
			(!this.props.community || getProfileUniqueName(this.props) !== paramUniqueName)
		) {
			props.retrieveCommunity(paramUniqueName);
		}
	}

	render() {
		if (!this.props.community || !this.props.community.profile) {
			return (
				<DocumentTitle title="B2Me">
					<main className="CommunityAdminPage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const {
			community: {
				uuid,
				type,
				noticesEnabled,
				noticesAllowAll,
				profile: {uniqueName}
			},
			toggleType,
			toggleNoticesEnabled,
			toggleNoticesAllowAll,
			confirmRemoval,
			sessionProvider
		} = this.props;

		const sessionUserMembership = getSessionUserMembership(this.props);
		const isAdmin = sessionProvider && sessionProvider.user && sessionProvider.user.admin;

		if (!isAdmin && (!sessionUserMembership || !sessionUserMembership.admin)) {
			// User is not an admin, should not be accessible.
			return <main className="CommunityAdminPage" />;
		}

		return (
			<DocumentTitle title={`${this.props.community.name} - B2Me`}>
				<main className="CommunityAdminPage">
					<section className="CommunityAdminPage-membership">
						<h2>Membership</h2>

						<ol>
							<li className="CommunityAdminPage-fancy-checkbox">
								<FancyCheckbox
									checked={type === 'closed'}
									id="closed-community"
									onChange={toggleType}
								/>
								<label htmlFor="closed-community">
									<span>Closed community</span>
								</label>
								<p className="CommunityAdminPage-note">
									If you select this option, an administrator will need to approve any new
									memberships.
								</p>
								{/*<p className="CommunityAdminPage-note">This option is only available for communities on <a href="#">paid plans</a>.</p>*/}
							</li>
						</ol>
					</section>

					<section className="CommunityAdminPage-noticeboard">
						<h2>Noticeboard</h2>

						<ol>
							<li className="CommunityAdminPage-fancy-checkbox">
								<FancyCheckbox
									checked={noticesEnabled}
									id="enable-noticeboard"
									onChange={toggleNoticesEnabled}
								/>
								<label htmlFor="enable-noticeboard">
									<span>Enable noticeboard</span>
								</label>
								{/*<p className="CommunityAdminPage-note">The community noticeboard can only be enabled on <a href="#">paid plans</a>.</p>*/}
							</li>
							<li className="CommunityAdminPage-fancy-checkbox">
								<FancyCheckbox
									checked={noticesAllowAll}
									id="noticeboard-ffa"
									onChange={toggleNoticesAllowAll}
								/>
								<label htmlFor="noticeboard-ffa">
									<span>Any member can add a notice</span>
								</label>
							</li>
						</ol>
					</section>

					<section className="CommunityAdminPage-membership">
						<h2>Sharing</h2>

						{/*<ol>*/}
						{/*<li className="CommunityAdminPage-fancy-checkbox">*/}
						{/*<FancyCheckbox checked="" id="allow-embed" />*/}
						{/*<label htmlFor="allow-embed">*/}
						{/*<span>Allow this community to be embedded in other sites</span>*/}
						{/*</label>*/}
						{/*</li>*/}
						{/*</ol>*/}

						<h3>Embedding code</h3>
						<ShareableLink
							snippet={`<iframe src="${window.location.protocol}//${
								window.location.host
							}/api/embed/!${uniqueName}" frameborder="0" width="800" height="500"></iframe>`}
						/>
						<p className="CommunityAdminPage-note">
							Paste this HTML code into another website to embed it.
						</p>

						<h3>Sign-up link</h3>
						<ShareableLink
							snippet={
								window.location.protocol +
								'//' +
								window.location.host +
								'/?signup_community=' +
								uniqueName
							}
						/>
						<p className="CommunityAdminPage-note">
							Share this link to enable others to sign-up to B2Me with your community.
						</p>

						<h3>Sharing link</h3>
						<ShareableLink
							snippet={window.location.protocol + '//' + window.location.host + '/!' + uniqueName}
						/>
						<p className="CommunityAdminPage-note">
							Share this link on Twitter, Facebook, email, and elsewhere.
						</p>
					</section>

					<section className="CommunityAdminPage-delete">
						<h2>Remove community</h2>
						<FancyButton onClick={() => confirmRemoval(uuid)}>
							I wish to remove this community
						</FancyButton>
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedCommunityAdminPage = connect(
	({community, session}) => ({
		community,
		sessionProvider: session && session.current
	}),
	dispatch => ({
		retrieveCommunity: uniqueName => dispatch(actions.retrieveCommunity(uniqueName)),
		toggleType: () => dispatch(actions.toggleType()),
		toggleNoticesEnabled: () => dispatch(actions.toggleNoticesEnabled()),
		toggleNoticesAllowAll: () => dispatch(actions.toggleNoticesAllowAll()),
		confirmRemoval: uuid =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to remove this community?`,
					message:
						'The community will no longer be visible on the site, which includes all of its notices, images and memberships. Are you sure?',
					onConfirm: () => {
						dispatch(actions.removeCommunity(uuid));
						dispatch(uiActions.uiMessage(`This community has now been removed`));
					}
				})
			)
	})
)(CommunityAdminPage);

export default ConnectedCommunityAdminPage;



// WEBPACK FOOTER //
// ./src/community/CommunityAdminPage.js